// extracted by mini-css-extract-plugin
export default {"container":"PeopleListToolbar_container__kfchg","leftContainer":"PeopleListToolbar_leftContainer__NImoA","rightContainer":"PeopleListToolbar_rightContainer__ixguI"};